import React from 'react';
import block from 'bem-cn';
import { useSelector } from 'react-redux';

import Copy from 'components/Copy';
import Modal from 'components/ModalProvider/Modal/Modal';
import SVG from 'components/SVG';

import useInvitePlayer from 'modules/App/model/useInvitePlayer/useInvitePlayer';

import copySVG from './img/copy.svg';
import crossSVG from './img/cross.svg';
import inviteSVG from './img/invite.svg';

import './InvitePlayer.scss';

const b = block('invite-player');

const InvitePlayer = () => {
  const locale = useSelector(state => state.locale.locale);
  const { handlers, values } = useInvitePlayer();

  if (values.isHidden) return null;

  return (
    <section className={b()}>
      <div className={b('base')} onClick={handlers.handleToggleModal}>
        <SVG className={b('icon')} svgProps={{ svg: inviteSVG }}  />
        {locale.invitePlayer}
      </div>
      {values.state.isOpen &&
        <Modal
          style={{ top: '25%', transform: 'translateX(-50%)' }}
          isPermanent
          content={
            <section className={b('modal')}>
              <div className={b('modal-header')}>
                {locale.invitePlayer}
                <SVG className={b('modal-cross')} svgProps={{ svg: crossSVG }} onClick={handlers.handleToggleModal} />
              </div>

              <div className={b('modal-bottom')}>
                <div className={b('modal-link')}>
                  {values.refCode ? values.refLink : locale.referralCodeNotFound}
                </div>
                {values.refCode && <Copy value={values.refLink}>
                  <SVG className={b('modal-copy')} svgProps={{ svg: copySVG }}  />
                </Copy>}
              </div>
            </section>}
        />}
    </section>
  );
};

export default InvitePlayer;
